import { render, staticRenderFns } from "./AttributeEditReplace.vue?vue&type=template&id=60dcc578&scoped=true&"
import script from "./AttributeEditReplace.vue?vue&type=script&lang=js&"
export * from "./AttributeEditReplace.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60dcc578",
  null
  
)

export default component.exports